<template>
  <BaseCardV2
    :titre="$vuetify.breakpoint.mobile || loading ? 'Ma tréso disponible' : ''"
    :btn-action="$vuetify.breakpoint.mobile && !hasCarteRemplie && !loading ? {
      libelle: 'Voir mes gains',
      icon: !abonnements.culturialAbonne ? 'mdi-lock' : '',
      hasOtherAtion: true
    } : null"
    class="pa-2"
    :has-help="hasCarteRemplie && !loading"
    @on-help="isOpenModalHelp = true"
    @otherAction="onClickInformationAbonnement()"
  >
    <div
      v-if="!hasCarteRemplie && !loading"
      class="mb-2"
    >
      <div
        class="d-flex "
        :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'justify-space-between mx-5'"
      >
        <div
          v-if="!$vuetify.breakpoint.mobile"
          class="align-self-center font-weight-bold secondary--text"
          :class="$vuetify.breakpoint.mobile ? 'titre-h4' : 'titre-h3'"
        >
          Ma tréso disponible
        </div>
        <div
          class="align-self-center d-flex"
          :class="$vuetify.breakpoint.mobile ? 'flex-column my-10' : ''"
        >
          <img
            src="@/assets/no-tresorerie.svg"
            alt="no-tresorerie"
            class=" align-self-center "
            :class="$vuetify.breakpoint.mobile ? 'mb-3' : 'mr-5 no-tresorerie align-center'"
          >
          <div class="align-self-center intro texte-gris-fonce">
            Découvrez la trésorerie dégagée par cette culture
          </div>
        </div>

        <div
          v-if="!$vuetify.breakpoint.mobile"
          class="mt-auto mb-3 mx-5"
        >
          <AgrButton
            color="primary "
            block
            large
            class="align-self-center"
            @click="onClickInformationAbonnement()"
          >
            <v-icon
              v-if="!abonnements.culturialAbonne"
              size="20"
              color="secondary"
              class="mr-3"
            >
              mdi-lock
            </v-icon>
            <span class="action text-truncate white--text">Voir mes gains</span>
          </AgrButton>
        </div>
      </div>
    </div>
    <div v-if="hasCarteRemplie || loading">
      <BaseLoader v-if="loading" />
      <div v-else>
        <div
          v-if="!$vuetify.breakpoint.mobile"
          class="font-weight-bold secondary--text ml-5"
          :class="$vuetify.breakpoint.mobile ? 'titre-h4' : 'titre-h3'"
        >
          Ma tréso disponible
        </div>
        <div
          class="d-flex"
          :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'justify-space-between my-5 ml-5'"
        >
          <div
            class="d-flex"
            :class="$vuetify.breakpoint.mobile ? 'flex-column align-center' : 'my-5 ml-5'"
          >
            <div class="d-flex">
              <div
                v-if="$vuetify.breakpoint.mobile"
                class="zone-operateur"
              />
              <div
                class="card mt-4 mt-md-0"
                :class="$vuetify.breakpoint.mobile ? '' : 'align-self-center'"
              >
                <div class="intro texte-gris-fonce mb-2">
                  Prix de vente
                </div>
                <div class="titre-h3 secondary--text">
                  {{ prixVenteEnEuroParTonne | roundNumber(0) | splitNumber }} €/t
                </div>
              </div>
            </div>
            <div
              class="d-flex"
              :class="$vuetify.breakpoint.mobile ? 'mt-4' : ''"
            >
              <div
                class="align-self-center d-flex justify-center"
                :class="$vuetify.breakpoint.mobile ? 'zone-operateur' : 'mx-6'"
              >
                <img
                  alt="picto-operateur-moins"
                  class="align-self-center"
                  src="@/assets/picto-operateur-moins.svg"
                >
              </div>
            
              <div class="card align-self-center">
                <div class="intro texte-gris-fonce mb-2">
                  Prix d'équilibre
                </div>
                <div class="titre-h3 secondary--text">
                  {{ prixEquilibreEnEuroParTonne | roundNumber(0) | splitNumber }} €/t
                </div>
              </div>
            </div>
            <div
              class="d-flex"
              :class="$vuetify.breakpoint.mobile ? 'mt-4' : ''"
            >
              <div
                class="align-self-center d-flex justify-center"
                :class="$vuetify.breakpoint.mobile ? 'zone-operateur' : 'mx-6'"
              >
                <img
                  alt="picto-operateur-egal"
                  class="align-self-center"
                  src="@/assets/picto-operateur-egal.svg"
                >
              </div>
              <div class="card align-self-center">
                <div class="intro texte-gris-fonce mb-2">
                  Tréso disponible
                </div>
                <div
                  class="titre-h3"
                  :class="couleurTreso"
                >
                  {{ tresoEnEuroParTonne | roundNumber(0) | splitNumber }} €/t
                </div>
              </div>
            </div>
            <div
              class="d-flex"
              :class="$vuetify.breakpoint.mobile ? 'mt-4' : ''"
            >
              <div
                class="align-self-center d-flex justify-center"
                :class="$vuetify.breakpoint.mobile ? 'zone-operateur' : 'mx-6'"
              >
                <div
                  class="intro texte-gris-fonce"
                  :class="$vuetify.breakpoint.mobile ? '' : 'mb-2'"
                >
                  Soit
                </div>
              </div>
              <div
                class="d-flex flex-column align-self-center montant-hectare"
                :class="[$vuetify.breakpoint.mobile ? 'largeur-carte' : '', hasHistoriqueTreso ? '' : 'justify-center']"
              >
                <div class="d-flex mr-2 align-self-center flex-wrap justify-center">
                  <div
                    class="chiffre-xxl mr-2 align-self-center"
                    :class="couleurTreso"
                  >
                    {{ tresoEnEuroParHectare | roundNumber(0) | splitNumber }}
                  </div>
                  <div
                    class="titre-h1 align-self-center"
                    :class="couleurTreso"
                  >
                    €/ha
                  </div>
                </div>
                <div
                  v-if="hasHistoriqueTreso"
                  class="titre-h3 secondary--text"
                >
                  <BaseEvolutionWithInfo
                    :evolution-value="evolutionTresoEnPourcentage"
                    :values="tresoParAnnee"
                    :unite="'€/ha'"
                  />
                </div>
              </div>
            </div>
          </div>
          <div :class="$vuetify.breakpoint.mobile ? 'mt-4 mb-2' : 'align-self-end'">
            <div
              class="d-flex"
              :class="$vuetify.breakpoint.mobile ? 'mr-16' : ''"
            >
              <div
                v-if="!loading && !erreur"
                class="align-self-center"
                :class="$vuetify.breakpoint.mobile ? 'mr-2' : 'position-indicateur-jauge'"
              >
                <UserIndicatorJauge
                  :chargement="chargementGroupe"
                  :data="{
                    value: positionJaugeGroupe(tresorerieDisponibleGroupe?.codePositionDuNumtiers)
                  }"
                  :unite="'€/ha'"
                  :is-parametres-exploitation-incomplet="!isParametresExploitationComplet"
                  :data-groupe="tresorerieDisponibleGroupe?.valeurMoyenneDuGroupe"
                  :negative-color="tresorerieDisponibleGroupe?.valeurMoyenneDuGroupe && isParametresExploitationComplet ? '#ec6608' : 'grey'"
                  :positive-color="tresorerieDisponibleGroupe?.valeurMoyenneDuGroupe && isParametresExploitationComplet ? '#01713c' : 'grey'"
                />
              </div>
              <AgrButton
                color="primary"
                large
                :block="$vuetify.breakpoint.mobile"
                class="align-self-center"
                :class="$vuetify.breakpoint.mobile ? '' : ' position-btn-plus-infos'"
                @click="isOpenModalDetail = true"
              >
                <v-icon>mdi-magnify-plus-outline</v-icon>
                <span class="action text-truncate white--text">Plus d'infos</span>
              </AgrButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <InformationAbonnementModal
      v-if="isOpenModalAideInformationAbonnement"
      :is-open-modal-information-abonnement="isOpenModalAideInformationAbonnement"
      code-feature="PRIX_EQUILIBRE_CULTURE"
      texte="Déterminez votre prix d'équilibre par culture en €/t grâce à un expert, pour vous aider dans votre commercialisation."
      titre="Mesurer la rentabilité technique et économique"
      :is-conseiller-pv-affiche="!isAbonneCulturial"
      @close="isOpenModalAideInformationAbonnement = false"
    />
    <MatriceGainModal
      v-if="isOpenModalDetail"
      :is-open-modal="isOpenModalDetail"
      :code-type-culture="codeGraineCulturialSelected"
      @close="isOpenModalDetail = false"
    />
    <HelpModal
      v-if="isOpenModalHelp"
      titre="Ma tréso disponible"
      :is-open-modal-help="isOpenModalHelp"
      @close="isOpenModalHelp = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-8">
          <p>
            Chacune des valeurs (prix de vente, prix d'équilibre et tréso disponible) étant arrondies à l'unité près, le montant de la tréso disponible par hectare peut légèrement différer de la formule Tréso disponible arrondie x rendement.
          </p>
          <p class="pt-2">
            Le calcul est le suivant :<br>
            Tréso disponible €/ha = Tréso disponible non arrondie en €/t x rendement
          </p>
        </div>
      </div>
    </HelpModal>
  </BaseCardV2>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { AgrButton } from '@agrial/ui'
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseEvolutionWithInfo from '@/components/common/base-evolution-with-info.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import InformationAbonnementModal from '@/views/offre-abonnement/components/modal/information-abonnement-modal.vue'
import MatriceGainModal from './modal/matrice-gain-modal.vue'
import UserIndicatorJauge from '@/components/chart/v2/user-indicator-jauge.vue'

export default {
  name: 'TresorerieDisponible',
  components: {AgrButton, BaseCardV2, BaseEvolutionWithInfo, BaseLoader, HelpModal, InformationAbonnementModal, MatriceGainModal, UserIndicatorJauge },
  props: {
    codeGraineCulturialSelected: {
      type: String,
      default: null
    },
    anneeRecolteSelected: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      erreur: false,
      chargementGroupe: false,
      isOpenModalAideInformationAbonnement: false,
      isOpenModalDetail: false,
      isOpenModalHelp: false
    }
  },

  computed: {
    ...mapGetters({
      abonnements: 'adherent/abonnements',
      atelierCultureVerrouillage: 'cloture/atelierCultureVerrouillage',
      atelierCultureVerrouillageCharge: 'cloture/atelierCultureVerrouillageCharge',
      atelierCultureVerrouillageErreur: 'cloture/atelierCultureVerrouillageErreur',
      filtresAdherent: 'filtresComparaison/filtresAdherent',
      tresorerieDisponible: 'cloture/tresorerieDisponible',
      tresorerieDisponibleChargee: 'cloture/tresorerieDisponibleChargee',
      evolutionTresorerieDisponible: 'cloture/evolutionTresorerieDisponible',
      tresorerieDisponibleGroupe: 'cloture/tresorerieDisponibleGroupe',
      isParametresExploitationComplet: 'parametresExploitation/isParametresExploitationComplet'
    }),
    isAbonneCulturial () {
      return this.abonnements.culturialAbonne
    },
    hasClotureVerrouillee () {
      return this.atelierCultureVerrouillage != null && this.atelierCultureVerrouillage.isAtelierVerrouille
    },
    donneesPerimees () {
      if (this.tresorerieDisponible == null || this.tresorerieDisponible.typeCulture == null) {
        return false
      }

      return this.tresorerieDisponible.typeCulture.code !== this.codeGraineCulturialSelected
        || String(this.tresorerieDisponible.anneeRecolte) !== String(this.anneeRecolteSelected)
    },
    loading () {
      if (this.atelierCultureVerrouillageErreur) {
        return false
      }

      if (!this.atelierCultureVerrouillageCharge) {
        return true
      }

      if (!this.isAbonneCulturial || !this.hasClotureVerrouillee) {
        return false
      }

      return !this.tresorerieDisponibleChargee || this.donneesPerimees
    },
    prixVenteEnEuroParTonne () {
      return this.tresorerieDisponible?.prixVenteEnEuroParTonne
    },
    prixEquilibreEnEuroParTonne () {
      return this.tresorerieDisponible?.prixEquilibreEnEuroParTonne
    },
    tresoEnEuroParTonne () {
      return this.tresorerieDisponible?.tresorerieDisponibleEnEuroParTonne
    },
    tresoEnEuroParHectare () {
      return this.tresorerieDisponible?.tresorerieDisponibleEnEuroParHectare
    },
    evolutionTresoEnPourcentage () {
      return this.evolutionTresorerieDisponible?.evolutionTresorerieEnPourcentage
    },
    tresoParAnnee () {
      return this.evolutionTresorerieDisponible?.tresorerieParAnnee
    },
    hasHistoriqueTreso () {
      return this.evolutionTresoEnPourcentage != null
    },
    hasCarteRemplie () {
      return this.isAbonneCulturial
        && this.hasClotureVerrouillee
        && this.tresoEnEuroParTonne != null
    },
    couleurTreso () {
      return this.tresoEnEuroParTonne != null && this.tresoEnEuroParTonne < 0 ? 'negatif--text' : 'positif--text'
    }
  },
  watch: {
    codeGraineCulturialSelected: {
      immediate: true,
      handler () {
        this.loadTresorerieDisponible()
      }
    },
    anneeRecolteSelected () {
      this.loadTresorerieDisponible()
    },
    hasClotureVerrouillee () {
      this.loadTresorerieDisponible()
    },
    isAbonneCulturial () {
      this.loadTresorerieDisponible()
    },
    filtresAdherent () {
      this.loadTresorerieDisponibleGroupe()
    }
  },
  methods: {
    ...mapActions({
      incrementerAccesSouscriptionAbonnement : 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement',
      getTresorerieDisponible: 'cloture/getTresorerieDisponible',
      getTresorerieDisponibleGroupe: 'cloture/getTresorerieDisponibleGroupe'
    }),
    loadTresorerieDisponible () {
      if (!this.isAbonneCulturial || !this.hasClotureVerrouillee || this.codeGraineCulturialSelected == null) {
        return
      }

      this.erreur = false
      this.getTresorerieDisponible(this.codeGraineCulturialSelected)
        .then(() => this.loadTresorerieDisponibleGroupe())
        .catch(() => { this.erreur = true })
    },
    loadTresorerieDisponibleGroupe () {
      if (!this.hasCarteRemplie) {
        return
      }

      this.chargementGroupe = true
      this.getTresorerieDisponibleGroupe(this.codeGraineCulturialSelected)
        .catch(() => {})
        .finally(() => {
          this.chargementGroupe = false
        })
    },
    positionJaugeGroupe (codePosition) {
      let result = null
      switch (codePosition) {
        case 'QUARTILE_SUP':
          result = 'positive'
          break
        case 'QUARTILE_INF':
          result = 'negative'
          break
        case 'MOYENNE':
          result = 'center'
          break
      }
      return result
    },
    onClickInformationAbonnement () {
      this.isOpenModalAideInformationAbonnement = true
      this.incrementerAccesSouscriptionAbonnement('PRIX_EQUILIBRE_CULTURE')
    }
  }
}

</script>

<style lang="scss" scoped>
.largeur-carte {
  width: 160px;
}
.zone-operateur {
  min-width: 40px;
}

.montant-hectare {
  max-width: 100%;
  overflow-wrap: anywhere;
}

.positif--text {
  color: #01713c;
}

.negatif--text {
  color: #ec6608;
}

.no-tresorerie {
  width: 20%;
}
.card {
  width: 180px;
  height: 85px;
  border: 1px solid #D7D8D6;
  border-radius: 16px;
  padding: 16px;
}
.position-indicateur-jauge {
  position: absolute;
  bottom: 18px;
  right: 180px;
}
.position-btn-plus-infos {
  position: absolute;
  bottom: 28px;
  right: 15px;
}
</style>
